/* Gretchen Masonry Heaters — main.js
   Nav toggle, reveal-on-scroll. Lightweight, no framework. */

(function () {
  "use strict";

  // --- Scroll-aware header --------------------------------------------
  // Header sits in the normal flow at the top. Once the user scrolls
  // past it, we switch to fixed positioning. From then on, scrolling
  // DOWN hides it; scrolling UP reveals it.
  const header = document.querySelector(".site-header");
  if (header) {
    let lastY = window.scrollY;
    let headerOffsetTop = header.getBoundingClientRect().top + window.scrollY;
    let headerHeight = header.offsetHeight;
    let ticking = false;

    const onResize = () => {
      // Re-measure when not floating (so we know when to switch)
      if (!header.classList.contains("site-header--floating")) {
        headerOffsetTop = header.getBoundingClientRect().top + window.scrollY;
        headerHeight = header.offsetHeight;
      }
    };

    const onHeaderScroll = () => {
      const y = window.scrollY;
      const delta = y - lastY;
      const past = y > headerOffsetTop + headerHeight;

      if (past && !header.classList.contains("site-header--floating")) {
        header.classList.add("site-header--floating");
        // Add a body padding so content doesn't jump when header becomes fixed
        document.body.style.paddingTop = headerHeight + "px";
      } else if (!past && header.classList.contains("site-header--floating") && y <= headerOffsetTop) {
        header.classList.remove("site-header--floating");
        header.classList.remove("is-hidden");
        document.body.style.paddingTop = "";
      }

      // Hide-on-down / show-on-up only when floating
      if (header.classList.contains("site-header--floating")) {
        if (delta > 6 && y > headerOffsetTop + headerHeight * 2) {
          header.classList.add("is-hidden");
        } else if (delta < -4) {
          header.classList.remove("is-hidden");
        }
      }

      lastY = y;
      ticking = false;
    };

    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(onHeaderScroll);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener("resize", onResize);
  }

  // --- Mobile nav -----------------------------------------------------
  const toggle = document.querySelector(".nav-toggle");
  const nav = document.getElementById("site-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.getAttribute("data-open") === "true";
      nav.setAttribute("data-open", String(!open));
      toggle.setAttribute("aria-expanded", String(!open));
      toggle.textContent = open ? "Menu" : "Close";
    });
  }

  // --- Reveal on scroll -----------------------------------------------
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const reveals = document.querySelectorAll(".reveal");
  if (reduced) {
    reveals.forEach((el) => el.setAttribute("data-visible", "true"));
  } else if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute("data-visible", "true");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.setAttribute("data-visible", "true"));
  }

  // --- Current year in footer -----------------------------------------
  const yearEl = document.querySelector("[data-year]");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  // --- Hearth eyebrow: time- and season-aware -------------------------
  // A small gesture: the dark story block greets you with the right
  // shade of the current day — like a shopkeeper looking up from a
  // ledger to say hello at the right hour.
  const eyebrow = document.querySelector(".hearth-eyebrow[data-place]");
  if (eyebrow) {
    const now = new Date();
    const h = now.getHours();
    const m = now.getMonth();
    const time =
      h < 5  ? "Predawn" :
      h < 9  ? "Morning" :
      h < 13 ? "Late morning" :
      h < 17 ? "Afternoon" :
      h < 20 ? "Dusk" :
      h < 23 ? "Evening" :
               "Late night";
    const season =
      (m === 11 || m <= 1) ? "Winter" :
      (m >= 2 && m <= 4)   ? "Spring" :
      (m >= 5 && m <= 7)   ? "Summer" :
                             "Autumn";
    const place = eyebrow.dataset.place || "";
    eyebrow.textContent = `${season} ${time.toLowerCase()}, ${place}`;
  }

  // --- Console message for the curious --------------------------------
  try {
    console.log(
      "%cGretchen Masonry Heaters",
      "font: 700 18px 'Bitter', Rockwell, serif; color: #a14c2d;"
    );
    console.log(
      "Pre-cut masonry heater kits that hold twelve hours from one load of wood.\n" +
      "Curious how they work? hello@gretchenmasonryheaters.com"
    );
  } catch (e) { /* noop */ }

  // --- Scroll progress bar --------------------------------------------
  const progress = document.querySelector(".scroll-progress");
  if (progress) {
    let ticking = false;
    const update = () => {
      const scrolled = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? Math.min(scrolled / max, 1) : 0;
      progress.style.setProperty("--progress", pct.toFixed(4));
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  // --- Hero mouse parallax --------------------------------------------
  // Layered depth effect: image drifts one way, copy drifts the opposite.
  // Uses CSS custom properties driven by raf-throttled mousemove.
  const hero = document.querySelector(".home-hero-bleed");
  if (hero && !reduced) {
    let hx = 0, hy = 0;       // target values (-1..1)
    let cx = 0, cy = 0;       // current smoothed values
    let heroRaf = 0;
    const onHeroMove = (e) => {
      const r = hero.getBoundingClientRect();
      hx = ((e.clientX - r.left) / r.width) * 2 - 1;   // -1..1
      hy = ((e.clientY - r.top) / r.height) * 2 - 1;
      if (!heroRaf) heroRaf = requestAnimationFrame(smooth);
    };
    const onHeroLeave = () => {
      hx = 0; hy = 0;
      if (!heroRaf) heroRaf = requestAnimationFrame(smooth);
    };
    const smooth = () => {
      // Exponential smoothing — low-pass filter for buttery motion
      cx += (hx - cx) * 0.12;
      cy += (hy - cy) * 0.12;
      hero.style.setProperty("--mx", cx.toFixed(3));
      hero.style.setProperty("--my", cy.toFixed(3));
      if (Math.abs(hx - cx) > 0.001 || Math.abs(hy - cy) > 0.001) {
        heroRaf = requestAnimationFrame(smooth);
      } else {
        heroRaf = 0;
      }
    };
    hero.addEventListener("mousemove", onHeroMove);
    hero.addEventListener("mouseleave", onHeroLeave);
  }

  // --- Hero scroll indicator ------------------------------------------
  // Fades the affordance once the user has scrolled past the hero's
  // first 40px (they got the message). Click smooth-scrolls one viewport
  // down regardless of where the next section actually starts, so the
  // gesture is independent of section structure. Used on home, about,
  // and delivery heroes.
  const heroScrolls = document.querySelectorAll("[data-hero-scroll]");
  if (heroScrolls.length) {
    const onHeroScrollFade = () => {
      const past = window.scrollY > 30;
      heroScrolls.forEach((el) => {
        el.dataset.hidden = past ? "true" : "false";
      });
    };
    window.addEventListener("scroll", onHeroScrollFade, { passive: true });
    onHeroScrollFade();
    heroScrolls.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({
          top: window.innerHeight,
          behavior: reduced ? "auto" : "smooth",
        });
      });
    });
  }

  // --- Hearth cursor-following ember glow -----------------------------
  // When the cursor enters the dark story block, a warm radial glow
  // tracks it — like holding a candle in a cabin.
  const hearth = document.querySelector(".home-hearth");
  if (hearth && !reduced) {
    const onHearthMove = (e) => {
      const r = hearth.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      hearth.querySelector(".hearth-overlay")?.style.setProperty("--ex", `${x.toFixed(1)}%`);
      hearth.querySelector(".hearth-overlay")?.style.setProperty("--ey", `${y.toFixed(1)}%`);
    };
    const onHearthLeave = () => {
      const overlay = hearth.querySelector(".hearth-overlay");
      if (overlay) {
        overlay.style.setProperty("--ex", "18%");
        overlay.style.setProperty("--ey", "88%");
      }
    };
    hearth.addEventListener("mousemove", onHearthMove);
    hearth.addEventListener("mouseleave", onHearthLeave);
  }

  // --- PDP: gallery + swatches ---------------------------------------
  // Ported from Amos Clayworks' product.liquid script. The hero <img>
  // intentionally has no srcset so a plain `img.src = url` swap takes
  // effect immediately. Color matching uses keyword tokens extracted
  // from the variant title slug, with stop-words filtered out.
  const heroImg = document.getElementById("gr-pdp-hero");
  const thumbStrip = document.getElementById("gr-thumbs-strip");

  function grSwapImage(btn, url) {
    if (!heroImg || !url) return;
    heroImg.style.opacity = "0";
    setTimeout(() => {
      heroImg.src = url;
      heroImg.onload = () => { heroImg.style.opacity = "1"; };
    }, 180);
    document.querySelectorAll(".gr-pdp__thumb").forEach((t) => t.classList.remove("is-active"));
    if (btn) {
      btn.classList.add("is-active");
      const strip = document.getElementById("gr-thumbs-strip");
      if (strip) strip.scrollTo({ left: btn.offsetLeft - strip.offsetWidth / 2 + btn.offsetWidth / 2, behavior: "smooth" });
    }
  }

  if (heroImg && thumbStrip) {
    thumbStrip.querySelectorAll(".gr-pdp__thumb").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const full = thumb.getAttribute("data-full");
        if (!full) return;
        grSwapImage(thumb, full);
      });
    });
  }

  document.querySelectorAll("[data-thumb-scroll]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const direction = parseFloat(btn.getAttribute("data-thumb-scroll")) || 1;
      const strip = document.getElementById("gr-thumbs-strip");
      if (strip) strip.scrollBy({ left: direction * 200, behavior: "smooth" });
    });
  });

  // --- PDP: variant swatch → switch variant + update form ------------
  const buyForm = document.getElementById("gr-buy-form");
  const variantsScript = document.getElementById("gr-variants-json");
  const imagesScript = document.getElementById("gr-images-json");
  let variants = null;
  let imagesData = [];
  if (variantsScript) {
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = null; }
  }
  if (imagesScript) {
    try { imagesData = JSON.parse(imagesScript.textContent); } catch (e) { imagesData = []; }
  }

  if (buyForm && variants && variants.length > 0) {
    const swatches = document.querySelectorAll(".gr-pdp__swatch");
    const priceEl = document.getElementById("gr-price");
    const buyBtn = buyForm.querySelector(".gr-pdp__add-btn");
    const consultCheckbox = document.getElementById("gr-consult-checkbox");

    // Selected options state, indexed by position (1, 2, 3)
    const selectedByPosition = {};
    swatches.forEach((sw) => {
      if (sw.classList.contains("is-active")) {
        const pos = sw.getAttribute("data-option-position");
        const val = sw.getAttribute("data-option-value");
        selectedByPosition[pos] = val;
      }
    });

    // Identify which option position drives image filtering. Anything
    // labelled Color/Colour/Finish/Stone Lining qualifies; size/stove-
    // option style options do not.
    let colorPosition = null;
    document.querySelectorAll(".gr-pdp__variant-select").forEach((wrap) => {
      const pos = wrap.getAttribute("data-option-position");
      const label = wrap.querySelector(".gr-pdp__variant-label");
      if (!pos || !label) return;
      const name = (label.textContent || "").toLowerCase();
      if (
        name.includes("color") ||
        name.includes("colour") ||
        name.includes("finish") ||
        name.includes("lining") ||
        name.includes("stone")
      ) {
        colorPosition = pos;
      }
    });

    // Stop-words mirror Amos's list — generic descriptors that appear in
    // both option values and alt text and would cause false matches.
    const STOP_WORDS = ["the","and","for","stone","thin","brick","home","kit","masonry","heater","sauna"];
    function getKeywords(colorSlug) {
      return colorSlug.split("-").filter((w) => w.length > 2 && STOP_WORDS.indexOf(w) === -1);
    }
    function thumbMatchesKeywords(thumbAlt, keywords) {
      for (let k = 0; k < keywords.length; k++) {
        if (thumbAlt.indexOf(keywords[k]) !== -1) return true;
      }
      return false;
    }
    function filterThumbsForColor(colorSlug) {
      const keywords = getKeywords(colorSlug);
      const thumbBtns = document.querySelectorAll(".gr-pdp__thumb");
      let firstVisible = null;
      // If no thumb has alt set, show all (images aren't tagged yet).
      let anyAltSet = false;
      thumbBtns.forEach((t) => { if (t.dataset.alt && t.dataset.alt.trim()) anyAltSet = true; });
      // If keywords list is empty after stop-word filtering, also show all.
      if (keywords.length === 0) anyAltSet = false;
      thumbBtns.forEach((thumb) => {
        const thumbAlt = (thumb.dataset.alt || "").toLowerCase();
        const matches = !anyAltSet || thumbMatchesKeywords(thumbAlt, keywords);
        thumb.style.display = matches ? "" : "none";
        if (matches && !firstVisible) firstVisible = thumb;
      });
      return firstVisible;
    }
    function findImageForColor(colorSlug) {
      const firstVisibleThumb = filterThumbsForColor(colorSlug);
      if (firstVisibleThumb) {
        return { src: firstVisibleThumb.dataset.full, thumb: firstVisibleThumb };
      }
      const keywords = getKeywords(colorSlug);
      for (let i = 0; i < imagesData.length; i++) {
        const alt = imagesData[i].alt || "";
        if (thumbMatchesKeywords(alt, keywords)) return { src: imagesData[i].src, thumb: null };
      }
      return null;
    }

    function findVariant() {
      const positions = Object.keys(selectedByPosition).map((k) => parseInt(k, 10)).sort();
      return variants.find((v) => positions.every((pos, i) => v.options[i] === selectedByPosition[pos]));
    }

    function updateFormAction() {
      const v = findVariant();
      if (!v) return;
      let action = "/cart/" + v.id + ":1";
      if (consultCheckbox && consultCheckbox.checked) {
        const consultId = consultCheckbox.getAttribute("data-consult-variant-id");
        if (consultId) action += "," + consultId + ":1";
      }
      buyForm.setAttribute("action", action);

      const installmentsIdInput = document.querySelector('#gr-installments-form input[name="id"]');
      if (installmentsIdInput && installmentsIdInput.value !== String(v.id)) {
        installmentsIdInput.value = v.id;
        installmentsIdInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (priceEl && v.price != null) {
        try {
          priceEl.textContent = new Intl.NumberFormat("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v.price / 100);
        } catch (e) {
          priceEl.textContent = (v.price / 100).toFixed(2);
        }
      }

      if (buyBtn) {
        if (v.available) buyBtn.removeAttribute("disabled");
        else buyBtn.setAttribute("disabled", "true");
      }
    }

    swatches.forEach((sw) => {
      sw.addEventListener("click", function () {
        const pos = this.getAttribute("data-option-position");
        const val = this.getAttribute("data-option-value");
        const colorSlug = this.getAttribute("data-color") || "";
        selectedByPosition[pos] = val;

        document.querySelectorAll(".gr-pdp__swatch[data-option-position='" + pos + "']").forEach((other) => {
          other.classList.remove("is-active");
        });
        this.classList.add("is-active");

        const labelEl = document.querySelector("[data-selected-option='" + pos + "']");
        if (labelEl) labelEl.textContent = val;

        // Resolve the variant first so we can prefer its featured_image,
        // and fall back to alt-text keyword matching when none is set.
        updateFormAction();
        if (pos === colorPosition) {
          const v = findVariant();
          let imageUrl = (v && v.featured_image) ? v.featured_image : "";
          let matchedThumb = null;
          if (!imageUrl) {
            const match = findImageForColor(colorSlug);
            if (match) { imageUrl = match.src; matchedThumb = match.thumb; }
          } else {
            // Still filter the thumb strip so only matching thumbs remain.
            filterThumbsForColor(colorSlug);
          }
          if (imageUrl) grSwapImage(matchedThumb, imageUrl);
        }
      });
    });

    if (consultCheckbox) {
      consultCheckbox.addEventListener("change", updateFormAction);
    }

    // Sync the initial active swatch to whatever color the hero image is
    // actually showing. Shopify renders the *first variant value* as the
    // default selected option, but the featured media is independent —
    // they often disagree (e.g. Tundra's first option is Red, but the
    // featured image is Green). When that happens, the hero is correct
    // and the swatch is wrong, so we move the active class to match.
    if (colorPosition && heroImg) {
      const heroAlt = (heroImg.alt || "").toLowerCase();
      const colorSwatches = document.querySelectorAll(".gr-pdp__swatch[data-option-position='" + colorPosition + "']");
      let bestMatch = null;
      colorSwatches.forEach((sw) => {
        if (bestMatch) return;
        const keywords = getKeywords(sw.getAttribute("data-color") || "");
        if (keywords.length && thumbMatchesKeywords(heroAlt, keywords)) bestMatch = sw;
      });
      if (bestMatch && !bestMatch.classList.contains("is-active")) {
        colorSwatches.forEach((s) => s.classList.remove("is-active"));
        bestMatch.classList.add("is-active");
        const pos = bestMatch.getAttribute("data-option-position");
        const val = bestMatch.getAttribute("data-option-value");
        selectedByPosition[pos] = val;
        const labelEl = document.querySelector("[data-selected-option='" + pos + "']");
        if (labelEl) labelEl.textContent = val;
        updateFormAction();
      }
    }

    // Filter thumbs on load for the (now correct) active color swatch.
    if (colorPosition) {
      const activeColorSwatch = document.querySelector(".gr-pdp__swatch[data-option-position='" + colorPosition + "'].is-active");
      if (activeColorSwatch) filterThumbsForColor(activeColorSwatch.getAttribute("data-color") || "");
    }
  }

  // --- PDP: Lightbox (magnify hero on click) ------------------------
  // Ported from Amos's amosLightboxOpen/Close. Bumps Shopify's width=
  // param to a higher value so the magnified view is sharp instead of
  // an upscaled 1200px source.
  (function () {
    const trigger = document.querySelector("[data-lightbox-trigger]");
    const lb = document.getElementById("gr-lightbox");
    const lbImg = document.getElementById("gr-lightbox-img");
    if (!trigger || !lb || !lbImg) return;

    function bumpWidth(url, target) {
      if (!url) return url;
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, "$1" + target);
      return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + target;
    }
    function open() {
      lbImg.src = bumpWidth(trigger.src, 2400);
      lbImg.alt = trigger.alt || "";
      lb.classList.add("is-open");
      lb.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    function close() {
      lb.classList.remove("is-open");
      lb.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    trigger.addEventListener("click", open);
    // Any element marked data-lightbox-close (backdrop or X button) closes.
    // The lightbox img itself stops propagation so clicks on it don't close.
    lb.querySelectorAll("[data-lightbox-close]").forEach((el) => el.addEventListener("click", close));
    lbImg.addEventListener("click", (e) => e.stopPropagation());
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && lb.classList.contains("is-open")) close();
    });
  })();

  // --- PDP: Reservation confirmation modal ---------------------------
  // Direct-to-checkout flow skips the cart, so a buyer who clicks
  // "Reserve Your Kit" lands on Shopify Checkout immediately. We pause
  // there with a modal that re-states the queue/freight/charge promise
  // before letting the form submit through.
  (function () {
    const form = document.getElementById("gr-buy-form");
    const modal = document.getElementById("gr-reserve-modal");
    if (!form || !modal) return;
    const confirmBtn = document.getElementById("gr-reserve-confirm");
    const closers = modal.querySelectorAll("[data-reserve-close]");
    let confirmed = false;
    let lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("gr-reserve-open");
      // Defer focus so the dialog is visible first, then move keyboard
      // focus to the primary action.
      requestAnimationFrame(() => { confirmBtn && confirmBtn.focus(); });
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove("gr-reserve-open");
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    form.addEventListener("submit", (e) => {
      if (confirmed) return; // user already confirmed — let it through
      e.preventDefault();
      open();
    });
    if (confirmBtn) {
      confirmBtn.addEventListener("click", () => {
        confirmed = true;
        close();
        // Re-trigger native submit; the listener above will let it through.
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
    closers.forEach((el) => el.addEventListener("click", close));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.hidden) close();
    });
  })();

  // --- Global contact popup -------------------------------------------
  // Any element with [data-contact-popup] or anchor with href="#contact-popup"
  // opens the modal. data-contact-kit="Tundra" pre-fills the kit field.
  (function () {
    const pop = document.getElementById("contact-popup");
    if (!pop) return;
    const kitInput = document.getElementById("gr-contact-pop-kit");
    const closers = pop.querySelectorAll("[data-contact-pop-close]");
    let lastFocus = null;

    function open(triggerEl) {
      lastFocus = document.activeElement;
      pop.hidden = false;
      pop.setAttribute("aria-hidden", "false");
      document.body.classList.add("gr-contact-pop-open");
      if (kitInput && triggerEl) {
        const kit = triggerEl.getAttribute("data-contact-kit");
        if (kit && !kitInput.value) kitInput.value = kit;
      }
      requestAnimationFrame(() => {
        const firstField = pop.querySelector("input, textarea");
        if (firstField) firstField.focus();
      });
    }
    function close() {
      pop.hidden = true;
      pop.setAttribute("aria-hidden", "true");
      document.body.classList.remove("gr-contact-pop-open");
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(
        "[data-contact-popup], a[href='#contact-popup'], a[href*='/pages/contact']"
      );
      if (!trigger) return;
      if (trigger.tagName === "A" && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;
      e.preventDefault();
      open(trigger);
    });
    closers.forEach((el) => el.addEventListener("click", close));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !pop.hidden) close();
    });

    // Auto-open if URL ends in #contact-popup (e.g. shared deep links).
    if (window.location.hash === "#contact-popup") {
      open(null);
    }
  })();

  // --- Testimonial marquee (Amos-style) -------------------------------
  // CSS handles the scroll animation. JS just keeps the first slide
  // centered at rest by setting --amos-testi-offset on the track.
  document.querySelectorAll(".amos-testi__marquee").forEach((marquee) => {
    const track = marquee.querySelector(".amos-testi__track");
    const slide = marquee.querySelector(".amos-testi__slide");
    if (!track || !slide) return;

    const updateOffset = () => {
      const offset = Math.max(0, (marquee.clientWidth - slide.clientWidth) / 2);
      track.style.setProperty("--amos-testi-offset", offset + "px");
    };

    updateOffset();
    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(updateOffset);
      ro.observe(marquee);
    } else {
      window.addEventListener("resize", updateOffset);
    }
  });
})();
